import Seo from '@/components/feature/Seo';
import { faqs, events } from '@/mocks/events';
import Hero from './components/Hero';
import Browse from './components/Browse';
import Focus from './components/Focus';
import EvidenceGrid from './components/EvidenceGrid';
import TruthMethod from './components/TruthMethod';
import FaqCta from './components/FaqCta';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: '69爆料',
      url: 'https://kpsdk.cn/',
      description: '吃瓜看证据，不站队。实锤证据汇总库，支持按事件、人物、时间多维检索，同步收录辟谣反锤。',
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: { '@type': 'EntryPoint', urlTemplate: 'https://kpsdk.cn/archive?q={search_term_string}' },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'ItemList',
      name: '精选事件档案',
      itemListElement: events.slice(0, 6).map((e, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        name: e.title,
        url: `https://kpsdk.cn/event/${e.slug}`,
      })),
    },
    {
      '@type': 'FAQPage',
      mainEntity: faqs.slice(0, 4).map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    },
  ],
};

export default function Home() {
  return (
    <>
      <Seo
        title="69爆料 - 实锤证据汇总库｜吃瓜看证据，不站队"
        description="69爆料专注实锤证据整理与事件档案汇总，持续补档更新聊天截图、转账记录、录音文件等硬核材料，支持按事件、人物、时间多维检索，并同步收录辟谣反锤内容，帮你分辨真假信息。"
        keywords="69爆料,69实锤截图,69爆料证据,69证据整理,69实锤汇总,吃瓜证据,辟谣反锤"
        canonicalPath="/"
        jsonLd={jsonLd}
      />
      <Hero />
      <Browse />
      <Focus />
      <EvidenceGrid />
      <TruthMethod />
      <FaqCta />
    </>
  );
}